import {ref, onMounted} from "vue";
import {useEventListener, useResizeObserver} from "@vueuse/core";

// the 50px .top-right keeps above the footer in App.vue and the page's own 20px
const FOOTER_GAP = 70

// a scrolling list grows down to the support footer instead of stopping at a
// fixed height, so the page ends with the gap the other sections have;
// `min` is the height every LK table had before
export default function useFillHeight(target, {min = 293} = {}) {
    const maxHeight = ref(`${min}px`)

    const sync = () => {
        const el = target.value
        const footer = document.querySelector('.bottom-right')
        if (!el || !footer) return

        // measured from the top of the document: the footer itself moves
        // down as the list grows, the viewport does not
        const top = el.getBoundingClientRect().top + window.scrollY
        const free = window.innerHeight - footer.offsetHeight - FOOTER_GAP - top

        maxHeight.value = `${Math.max(min, Math.floor(free))}px`
    }

    // the cards above load and wrap, the window resizes
    useResizeObserver(document.body, sync)
    useEventListener(window, 'resize', sync, {passive: true})
    onMounted(sync)

    return {maxHeight}
}
